module.exports = __webpack_public_path__ + "img/hearth.76a1a313.png";